// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3XGku","image":"Header_image__2gg9l","name":"Header_name__2Q3zH","info":"Header_info__1QY4Y","infoRow":"Header_infoRow__3Cmq_"};